module.exports = __webpack_public_path__ + "static/media/Bower-Bold.ed918c1b.woff";